module.exports = __webpack_public_path__ + "static/media/arrow-right.f9f24497.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-right.svg
// module id = 1445
// module chunks = 0